import { render } from "./CommentFilterButton.vue?vue&type=template&id=3c6854ab&scoped=true"
import script from "./CommentFilterButton.vue?vue&type=script&lang=js"
export * from "./CommentFilterButton.vue?vue&type=script&lang=js"

import "./CommentFilterButton.vue?vue&type=style&index=0&id=3c6854ab&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6854ab"]])

export default __exports__